import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.slice.js";
import ModifyPwd from "./modify-pwd.vue";
import ChangePhone from "./change-phone.vue";
import ResetPwd from "./reset-pwd.vue";
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
export default {
  name: "account-security",
  components: {
    ModifyPwd: ModifyPwd,
    ChangePhone: ChangePhone,
    ResetPwd: ResetPwd
  },
  inject: ["reload"],
  data: function data() {
    return {
      account: null,
      startPhone: null,
      Phonedata: [],
      endPhone: [],
      curIndex: 1,
      //切换组键
      isBindPhone: false
    };
  },
  created: function created() {
    this.account = accountStorage.getCacheUserInfo().account;
    this.getPhone();
  },
  methods: {
    back: function back(fresh) {
      if (fresh) {
        this.reload();
      }
      this.curIndex = 1;
    },
    getPhone: function getPhone() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/pjyy-deepexi-user-center/api/v1/customer/getCustomerPhoneLst?";
              _context.next = 3;
              return _this.$getHttpClient().get(url);
            case 3:
              res = _context.sent;
              if (res.data.code == "200") {
                _this.Phonedata = res.data.data;
                _this.startPhone = _this.Phonedata[0];
                _this.endPhone = _this.Phonedata.slice(1, _this.Phonedata.length);
                _this.isBindPhone = _this.startPhone ? true : false;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};